import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Impressum from './components/Impressum';
import Datenschutz from './components/Datenschutz';
import { Toaster } from './components/ui/toaster';

function App() {
  useEffect(() => {
    // Load Inter font for consistent typography
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  const HomePage = () => (
    <>
      <Hero />
      <Gallery category="landscape" title="Landschaftsfotografie" />
      <Gallery category="portrait" title="Porträtfotografie" />
      <Gallery category="sports" title="Sportfotografie" />
      <Gallery category="general" title="Allgemeine Arbeiten" />
      <About />
      <Projects />
      <Contact />
    </>
  );

  return (
    <BrowserRouter>
      <div className="App bg-black">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
        <Footer />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;